import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as driveRoutes } from './drive/drive.routes';
import { routes as bookmarksRoutes } from './bookmarks/bookmarks.routes';
import { routes as tasksRoutes } from './tasks/routes';
import { routes as taxisRoutes } from './taxis/routes';
import { routes as websiteRoutes } from './website/routes';
import { routes as clientPortalsRoutes } from './client_portals/routes';
import { routes as homeRoutes } from './home/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...homeRoutes,
        ...captainRoutes,
        ...driveRoutes,
        ...bookmarksRoutes,
        ...tasksRoutes,
        ...taxisRoutes,
        ...websiteRoutes,
        ...clientPortalsRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
